import { Skeleton } from '@ui/v2/Skeleton'

import { Box } from '@shared/components/Box/Box'

import { SparklineSkeleton } from './components/Sparkline'

import styles from './Instruments.module.scss'

export const InstrumentCardSkeleton = () => (
  <div className={styles.mobileCard}>
    <div className={styles.mobileCardHeader}>
      <Box flex align='center' justify='space-between'>
        <div className={styles.mobileTitleBlock}>
          <Skeleton width={120} variant='text' />
        </div>
        <Skeleton width={50} variant='text' />
      </Box>
      <Box flex align='center' gap='x4' justify='space-between' className={styles.bottomBlock}>
        <Skeleton width={150} variant='text' />
        <SparklineSkeleton width={120} height={32} />
      </Box>
    </div>
    <div className={styles.mobileFooter}>
      <Skeleton width='100%' height={36} variant='rounded' />
      <Skeleton width='100%' height={36} variant='rounded' />
    </div>
  </div>
)
